import { useContext, useEffect, useState, useCallback } from "react";
import { Formik, Form } from "formik"
import * as Yup from 'yup';
import { EditableContext } from "common/EditableContextProvider";
import { Select, Button, DatePicker, Checkbox } from "antd";
import { ErrorMessage } from "formik";
import dayjs from "dayjs";

export const FormComponent = () => {
    const { context } = useContext(EditableContext);
    const { FormBase } = context;
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({});

    const [programado, setProgramado] = useState(false);

    const defaultItem = {
        campaign_id: "",
        contact_list_id: "",
        date_start: null,
        repeat_weekly: false
    }

    useEffect(() => {
        setInitialValues(getInitialValues());
    }, [context.editID]);

    const getInitialValues = useCallback(
        () => {
            let it = context.getItemSelected();
            if (!it) { it = defaultItem; }
            else { it = { ...it }; }
            return it;
        }, [context.editID]);

    const validateSchema = Yup.object({
        campaign_id: Yup.number()
            .required('El campo es obligatorio'),
        contact_list_id: Yup.number()
            .required('El campo es obligatorio'),
    });

    const handleSubmit = async (values, formik) => {
        try {
            setIsLoading(true);
            let id = await context.saveItem(values, formik);
            if (id) {
                formik.setFieldValue('id', id);
                setInitialValues(prev => ({...prev, ...values, id: id}));
            } else { setInitialValues(prev => ({...prev, ...values})); }
        } catch (error) {
            const { errors } = error.response.data;
            let keys = Object.keys(errors);
            keys.forEach((key) => {
                formik.setFieldError(key, errors[key][0]);
            });
        }
        finally { setIsLoading(false); }
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validateSchema}
            enableReinitialize={true}
        >
            {
                (formik) => (
                    <Form>
                        <fieldset disabled={FormBase.isLoading}>
                            <div className="mb-3">
                                <label className="form-label" htmlFor="">Lista de contactos</label>
                                <Select
                                    className="w-100"
                                    options={context.listContacts.items.map(cp => ({
                                        value: cp.id,
                                        label: cp.name
                                    }))}
                                    value={formik.values.contact_list_id}
                                    onChange={(value) => formik.setFieldValue("contact_list_id", value) }
                                    placeholder="Seleccionar lista de contactos"
                                ></Select>
                                <ErrorMessage name="contact_list_id" component={FormBase.FormError} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label" htmlFor="">Campaña:</label>
                                <Select
                                    className="w-100"
                                    options={context.campaigns.items.map(cp => ({
                                        value: cp.id,
                                        label: cp.name
                                    }))}
                                    value={formik.values.campaign_id}
                                    onChange={(value) => formik.setFieldValue("campaign_id", value) }
                                    placeholder="Seleccionar campaña"
                                ></Select>
                                <ErrorMessage name="campaign_id" component={FormBase.FormError} />
                            </div>

                            <div className="mb-3">
                                <span className="d-block py-1" htmlFor="">
                                    <Checkbox className="me-2" checked={programado}
                                        onChange={(e) => {
                                            if(!e.target.checked) {
                                                formik.setFieldValue('date_start', null);
                                                formik.setFieldValue('repeat_weekly', false);
                                            };
                                            setProgramado(e.target.checked);
                                        }}
                                    >
                                        Envío Programado
                                    </Checkbox>
                                </span>
                                {
                                    (programado)? (
                                        <>
                                            <DatePicker
                                                minDate={dayjs()}
                                                className="w-100"
                                                showTime={{ format: "HH:mm" }}
                                                value={formik.values.date_start ? dayjs(formik.values.date_start) : null}
                                                onChange={(value) => formik.setFieldValue('date_start', value.format('YYYY-MM-DD HH:mm:ss'))}
                                                minuteStep={15}
                                            />
                                            <div className="text-end my-3 ms-5">
                                                <Checkbox className=""
                                                    checked={formik.values.repeat_weekly}
                                                    onChange={(e) => {
                                                        if(!e.target.checked) { formik.setFieldValue('date_start', null) };
                                                        formik.setFieldValue('repeat_weekly', e.target.checked);
                                                    }}
                                                >
                                                    Repetir cada semana.
                                                </Checkbox>
                                            </div>
                                        </>
                                    ) : null
                                }
                            </div>

                            <div className="mb-2">
                                <div className="row">
                                    <div className="col">
                                        <button type="button" className="btn btn-sm btn-danger w-100"
                                            onClick={() => context.modalBase.close()}
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                    <div className="col">
                                        <button type="submit" className="btn btn-sm btn-dark w-100"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Guardando..." : "Guardar"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </Form>
                )
            }

        </Formik>
    )

}
